<script>
import axios from 'axios';
import { suggestions, followSuggestionUser, followSuggestionCampaign, followSuggestionCandidate } from '../api/suggestions';
import VClamp from 'vue-clamp';

export default {
    name: 'CpSuggestionDialog',
    directives: {
        margin: require('../directives/margins').margin,
        marginBottom: require('../directives/margins').marginBottom,
        marginTop: require('../directives/margins').marginTop
    },
    components: {
        CpPageContent: require('../page-content').default,
        CpBox: require('../box').default,
        CpBoxContent: require('../box-content').default,
        CpGrid: require('../grid').default,
        CpGridItem: require('../grid-item').default,
        CpButton: require('../button').default,
        CpButtonLink: require('../button-link').default,
        CpDialog: require('../dialog').default,
        CpImage: require('../image').default,
        CpBaseSvgIcon: require('../base-svg-icon').default,
        SuggestionCompleteIcon: require('../social-feed/icons/suggestion-complete').default,
        VClamp,
        VueSimpleSpinner: require('../vue-simple-spinner').default
    },
    props: {
        fullScreen: Boolean,
        suggestions: Array,
        handleSuggestionDialog: Function,
        handleProfileDialog: Function,
        handleJoinGroupDialog: Function,
        user: Object,
        loadingSuggestions: Boolean
    },
    data() {
        return {
            loadingFollow: false,
            followingIndex: undefined,
            showSuggestionDialog: true
        };
    },
    methods: {
        handleDialogs() {
            this.handleProfileDialog(true);
            this.handleSuggestionDialog(false);
        },
        finish() {
            this.handleSuggestionDialog(false, 'finish');
            this.handleJoinGroupDialog(true);
        },
        followUser(user_id, index) {
            this.followingIndex = index;
            this.loadingFollow = true;

            followSuggestionUser(user_id).then(response => {
                this.suggestions = this.suggestions.filter((_, i) => i != index);  
            }).finally(() => {
                this.followingIndex = undefined;
                this.loadingFollow = false;
            })
        },
        followCampaign(campaign_id, index) {
            this.followingIndex = index;
            this.loadingFollow = true;

            followSuggestionCampaign({ type: 'crowdpac_follow', type_id: Number(campaign_id) }).then(response => {
                this.suggestions = this.suggestions.filter((_, i) => i != index);
            }).finally(() => {
                this.followingIndex = undefined;
                this.loadingFollow = false;
            })
        },
        followCandidate(candidate_id, index) {
            this.followingIndex = index;
            this.loadingFollow = true;

            followSuggestionCandidate({ type: 'candidate_follow', type_id: Number(candidate_id) }).then(response => {
                this.suggestions = this.suggestions.filter((_, i) => i != index);
            }).finally(() => {
                this.followingIndex = undefined;
                this.loadingFollow = false;
            })
        },
        reloadFeed() {
            window.location.href = '/feed';
        }
    }
};
</script>

<template>
    <cp-dialog v-if="showSuggestionDialog && user" :full-screen="fullScreen">
        <cp-page-content style="margin-top: 40px; overflow-x: hidden">
            <cp-grid>
                <cp-grid-item :span="$root.isMobile ? 10 : 8" :offset="$root.isMobile ? 0 : 2">
                    <div style="text-align: center">
                        <h2 class="title-align" style="text-align: center">Follow Candidates, Campaigns, and Users Making an Impact.</h2>
                    </div>
                </cp-grid-item>
                <cp-grid-item :span="$root.isMobile ? 2 : 1" :offset="$root.isMobile ? 0 : 1">
                    <cp-button @click="reloadFeed">Skip</cp-button>
                </cp-grid-item>
            </cp-grid>
            <div>
                <div v-if="loadingSuggestions" class="heading-4" style="text-align: center"><vue-simple-spinner v-margin="1" />Loading Suggestions...</div>
                <cp-box v-else-if="suggestions.length != 0" v-margin="0.5">
                    <cp-box-content v-for="(suggestion, index) in suggestions" :key="index">
                        <cp-grid v-if="suggestion.type == 'Member'" style="margin-bottom: 20px">
                            <cp-grid-item :span="$root.isMobile ? 4 : 6" class="vertically-centered" style="float: right">
                                <cp-image
                                    class="suggestion-image"
                                    :src="suggestion.image"
                                    rounded
                                    :alt="suggestion.name"
                                    :width="'100%'"
                                    :height="$root.isMobile ? '30' : '50'"
                                ></cp-image>
                            </cp-grid-item>
                            <cp-grid-item :span="$root.isMobile ? 8 : 6" class="vertically-centered box-details">
                                <span style="margin-bottom: 10px">
                                    <v-clamp autoresize :max-lines="2" class="text-size" style="color: #ff4814"> {{ suggestion.name }} </v-clamp>
                                    <p class="text-size">Popular User</p>
                                </span>
                                <cp-button
                                    primary-gradient
                                    @click="followUser(suggestion.suggestionable_id, index)"
                                    :loading="followingIndex === index"
                                    :disabled="followingIndex"
                                    class="btn-follow"
                                    >Follow</cp-button
                                >
                            </cp-grid-item>
                        </cp-grid>

                        <cp-grid v-else-if="suggestion.type == 'Campaing'" style="margin-bottom: 20px">
                            <cp-grid-item :span="$root.isMobile ? 4 : 6" class="vertically-centered">
                                <img class="suggestion-image" :src="suggestion.image" alt />
                            </cp-grid-item>
                            <cp-grid-item :span="$root.isMobile ? 8 : 6" class="vertically-centered box-details">
                                <span style="margin-bottom: 10px">
                                    <v-clamp autoresize :max-lines="1" class="text-size" style="color: #ff4814"> {{ suggestion.name }} </v-clamp>
                                    <p class="text-size">Trending Campaign</p>
                                </span>
                                <cp-button
                                    primary-gradient
                                    @click="followCampaign(suggestion.suggestionable_id, index)"
                                    :loading="followingIndex === index"
                                    :disabled="followingIndex"
                                    class="btn-follow"
                                    >Follow</cp-button
                                >
                            </cp-grid-item>
                        </cp-grid>

                        <cp-grid v-else-if="suggestion.type == 'Candidate'" style="margin-bottom: 20px">
                            <cp-grid-item :span="$root.isMobile ? 4 : 6" class="vertically-centered">
                                <cp-image class="suggestion-image" :src="suggestion.image" alt="" :width="'100%'" rounded></cp-image>
                            </cp-grid-item>
                            <cp-grid-item :span="$root.isMobile ? 8 : 6" class="vertically-centered box-details">
                                <span style="margin-bottom: 10px">
                                    <v-clamp autoresize :max-lines="2" class="text-size" style="color: #ff4814"> {{ suggestion.name }} </v-clamp>
                                    <p class="text-size">Trending Candidate</p>
                                </span>
                                <cp-button
                                    primary-gradient
                                    @click="followCandidate(suggestion.suggestionable_id, index)"
                                    :loading="followingIndex === index"
                                    :disabled="followingIndex"
                                    class="btn-follow"
                                    >Follow</cp-button
                                >
                            </cp-grid-item>
                        </cp-grid>
                    </cp-box-content>
                </cp-box>
                <cp-box v-else v-margin="0.5">
                    <h1 style="text-align: center">Good Work!</h1>
                    <h2 style="font-weight: normal; text-align: center">Your profile is all setup.</h2>
                    <div style="text-align: center; margin: 50px 0 100px">
                        <cp-base-svg-icon
                            :width="201"
                            :height="201"
                            :viewBox="'0 0 201 201'"
                            :icon-color="'currentColor'"
                            :stroke-color="'none'"
                            style="vertical-align: middle"
                        >
                            <suggestion-complete-icon />
                        </cp-base-svg-icon>
                    </div>
                </cp-box>
                <cp-box v-margin="0.5">
                    <cp-grid>
                        <cp-grid-item :span="12" style="text-align: center">
                            <cp-button @click="handleDialogs" class="btn-suggestion" style="margin-right: 20px"> Back </cp-button>
                            <cp-button primary-gradient @click="finish" class="btn-suggestion">Finish</cp-button>
                        </cp-grid-item>
                    </cp-grid>
                </cp-box>
            </div>
        </cp-page-content>
    </cp-dialog>
</template>

<style scoped>
.mobile-dialog-header {
    margin-top: 80px;
}
.mobile-dialog-header h2 {
    font-size: 22px;
    margin-top: 10px;
}
.content-5 {
    font-size: 18px;
    line-height: 21px;
}
.vertically-centered {
    justify-content: center;
    flex-direction: column;
}
.box-details {
    position: relative;
}
.btn-follow {
    width: 200px;
    position: absolute;
    bottom: 0;
}
.text-size {
    font-size: 24px;
}
.crowdpac-image {
    height: 150px;
    width: 150px;
    border-radius: 4px;
    object-fit: cover;
}
.suggestion-image {
    float: right;
}
@media only screen and (min-width: 1024px) {
    .btn-suggestion {
        width: 300px;
    }
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
    .title-align {
        margin-left: 120px;
    }
    .btn-suggestion {
        width: 200px;
    }
}
@media only screen and (max-width: 767px) {
    .title-align {
        margin-left: 60px;
    }
    .btn-suggestion {
        width: 100px;
    }
    .suggestion-image {
        float: none;
    }
    .crowdpac-image {
        height: 92px;
        width: 100%;
        border-radius: 4px;
        object-fit: cover;
    }
    .text-size {
        font-size: 16px;
    }
}
</style>
